import angular from 'angular';
import imageComponent from './image.component';

let imageModule = angular.module('image', [])

.component('drmImage', imageComponent)

.name;

export default imageModule;



// WEBPACK FOOTER //
// ./client/app/components/content-types/image/image.js